import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { tap, filter, take } from 'rxjs/operators';

import { CoreState } from '@app/store/core/states';
import { UtilityHelper } from '@framework/utilities';
import { LoadStatusModel } from '../models';
import { appSettingSelector } from '../store/selectors';
import { appSettingActions } from '../store/actions';

@Injectable()
export class AppSettingGuard  {
    constructor(private store$: Store<CoreState>, private utilities: UtilityHelper, private router: Router) {

    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return new Promise((resolve, reject) => {
            this.getAppSetting().toPromise().then(() => {
                resolve(true);
            }, error => {
                resolve(false);
                this.router.navigate(['/user/login']);
            });
        });
    }

    private getAppSetting(): Observable<any> {
        return this.store$
            .select(appSettingSelector.selectLoadStatus)
            .pipe(
                tap((loadStatus: LoadStatusModel) => {
                    if (!loadStatus.isLoaded && !loadStatus.isLoading) {
                        return this.store$.dispatch(new appSettingActions.LoadAppSetting());
                    }
                }),
                filter((loadStatus) => loadStatus.isLoaded === true),
                take(1)
            );
    }
}